import { Button, Checkbox, Form, Icon, Input, message, Tooltip } from "antd";
import { FormComponentProps } from "antd/lib/form";
import React from "react";
import "./style.css";

interface Props extends FormComponentProps {
  changeStatus: (data: any) => any;
  history: any;
  login: (data: any) => any;
}

class NormalLoginForm extends React.Component<Props> {
  state = {
    status: "login",
  };
  handleSubmit = (e: any) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const { userName, password } = values;
        if (userName === "admin" && password === "12345678q") {
          let data = {
            userName: values.userName,
            password: values.password,
          };
          sessionStorage.setItem("nav", JSON.stringify(data));
        } else {
          return message.error("用户名或密码错误");
        }
        // let data = {
        //   userName: values.userName,
        //   password: values.password
        // };
        // this.props.login(getEncryption(data))
        // .then(
        //   (res: any) => {
        //     if (!res.error) {
        //       this.props.history.push('/');
        //     } else {
        //       this.props.form.resetFields(['password'])
        //     }
        //   }
        // )

        this.props.history.push("/");
      } else {
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <Form onSubmit={this.handleSubmit} className="login-form">
        <h1>登录</h1>
        <Form.Item>
          {getFieldDecorator("userName", {
            rules: [{ required: true, message: "请输入用户名!" }],
          })(
            <Input
              prefix={<Icon type="user" style={{ color: "rgba(0,0,0,.25)" }} />}
              placeholder="用户名"
            />
          )}
        </Form.Item>
        <Form.Item>
          {getFieldDecorator("password", {
            rules: [{ required: true, message: "请输入密码!" }],
          })(
            <Input
              prefix={<Icon type="lock" style={{ color: "rgba(0,0,0,.25)" }} />}
              type="password"
              placeholder="密码"
            />
          )}
        </Form.Item>
        <Form.Item>
          {getFieldDecorator("remember", {
            valuePropName: "checked",
            initialValue: true,
          })(<Checkbox>免登录</Checkbox>)}
          <Tooltip placement="top" title={"请联系管理员"}>
            <a className="login-form-forgot">忘记密码</a>
          </Tooltip>
          <div className="login_button">
            <Button
              type="primary"
              htmlType="submit"
              className="login-form-button"
            >
              登录
            </Button>
          </div>

          {/* <a onClick={this.props.changeStatus}>注册</a> */}
        </Form.Item>
      </Form>
    );
  }
}

const Login: any = Form.create({ name: "normal_login" })(NormalLoginForm);

export default Login;
